import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/thumbnail/context.tsx
const ThumbnailContext = createContext(null);
function ThumbnailProvider({ value, children }) {
	return /* @__PURE__ */ jsx(ThumbnailContext.Provider, {
		value,
		children
	});
}
function useThumbnailContext() {
	const ctx = useContext(ThumbnailContext);
	if (!ctx) throw new Error("Thumbnail compound components must be used within a Thumbnail.Root");
	return ctx;
}
//#endregion
export { ThumbnailProvider, useThumbnailContext };

//# sourceMappingURL=context.js.map